function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgCredit = function SvgCredit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#146AA8"
    },
    d: "M481.53,347.033l30.015-191.649c3.121-19.448-10.112-37.747-29.561-40.877l0,0L76.973,49.501 C57.525,46.38,39.227,59.613,36.106,79.061l-14.392,89.627v177.23L481.53,347.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#126099"
    },
    d: "M481.985,114.507L366.953,96.049C289.694,214.264,164.799,296.142,69.019,346.034l412.511,0.999 l30.015-191.649C514.666,135.935,501.433,117.637,481.985,114.507L481.985,114.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4398D1"
    },
    d: "M35.669,159.771h410.192c19.698,0,35.669,15.971,35.669,35.669v231.848 c0,19.698-15.971,35.669-35.669,35.669H35.669C15.971,462.956,0,446.986,0,427.288V195.44C0,175.742,15.971,159.771,35.669,159.771z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E8CC7"
    },
    d: "M445.861,159.771h-7.134c-84.179,149.444-241.469,251.956-337.49,303.185h344.624 c19.698,0,35.669-15.971,35.669-35.669V195.44C481.53,175.742,465.559,159.771,445.861,159.771z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.586,
    y: 204.357,
    style: {
      fill: "#FDB62F"
    },
    width: 89.172,
    height: 71.338
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.586,
    y: 231.109,
    style: {
      fill: "#FD7B2F"
    },
    width: 26.752,
    height: 17.834
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.007,
    y: 231.109,
    style: {
      fill: "#FD7B2F"
    },
    width: 26.752,
    height: 17.834
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FDB62F"
    },
    cx: 392.358,
    cy: 373.784,
    r: 44.586
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DE4C3C"
    },
    cx: 338.854,
    cy: 373.784,
    r: 44.586
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.669,
    y: 338.115,
    style: {
      fill: "#87CED9"
    },
    width: 53.503,
    height: 17.834
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.841,
    y: 338.115,
    style: {
      fill: "#87CED9"
    },
    width: 53.503,
    height: 17.834
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.013,
    y: 338.115,
    style: {
      fill: "#87CED9"
    },
    width: 53.503,
    height: 17.834
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.669,
    y: 391.619,
    style: {
      fill: "#87CED9"
    },
    width: 231.848,
    height: 17.834
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.103,
    y: 204.357,
    style: {
      fill: "#87CED9"
    },
    width: 17.834,
    height: 35.669
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.772,
    y: 204.357,
    style: {
      fill: "#87CED9"
    },
    width: 17.834,
    height: 35.669
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.44,
    y: 204.357,
    style: {
      fill: "#87CED9"
    },
    width: 17.834,
    height: 35.669
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.109,
    y: 204.357,
    style: {
      fill: "#87CED9"
    },
    width: 17.834,
    height: 35.669
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCredit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit.dd348025.svg";
export { ForwardRef as ReactComponent };